<template>
  <div id="app">
    <router-view />
    <!-- <el-dialog
      title="登录"
      :visible.sync="isUserLogin"
      center
      :append-to-body="true"
      :lock-scroll="false"
      width="40%"
      custom-class="login_class"
      :before-close="handleClose"
      class="login_dialog"
    >
      <el-form class="password_form" ref="form" :model="form" id="login">
        <el-form-item
          style="border-bottom: 1px #dcdfe6 solid; padding-bottom: 10px"
        >
          <span class="icon_01"></span>
          <input
            v-model.trim="form.username"
            style="
              font-size: 18px;
              padding-left: 10px;
              border: none;
              display: inline-block;
              width: 85%;
              vertical-align: bottom;
            "
            placeholder="请输入用户名"
          />
        </el-form-item>
        <el-form-item
          style="border-bottom: 1px #dcdfe6 solid; padding-bottom: 10px"
        >
          <span class="icon_02"></span>
          <input
            v-model.trim="form.password"
            style="
              font-size: 18px;
              padding-left: 10px;
              border: none;
              display: inline-block;
              width: 85%;
              vertical-align: bottom;
            "
            placeholder="请输入登录密码"
            type="password"
          />
        </el-form-item>
        <el-form-item>
          <button class="login_button" type="primary" @click.prevent="loginBtn">
            登 录
          </button>
        </el-form-item>
      </el-form>
    </el-dialog>-->
    <div class="loginDia" v-if="isUserLogin">
      <div class="loginBody">
        <img class="cancel_icon" @click="outerDia" src="..//static/20210517new/cancel.png" alt />
        <div class="loginBody_left">
          <img style="width: 100%; height: 100%" src="../static/20210517new/login_left.png" alt />
        </div>
        <div class="loginBody_right">
          <div class="login_title">用户登录</div>
          <el-input
            v-model="formInline.username"
            placeholder="请输入用户名"
            clearable
            style="
              width: 80%;
              margin-left: 10%;
              margin-top: 50px;
              margin-bottom: 20px;
            "
            @focus="getFocusUser"
            @blur="getBlurUser"
            @keyup.enter.native="loginBtn"
            :prefix-icon="
              userType == 0 ? 'el-icon-login-user' : 'el-icon-login-user_active'
            "
          ></el-input>
          <el-input
            v-model="formInline.password"
            placeholder="请输入密码"
            clearable
            show-password
            style="width: 80%; margin-left: 10%"
            @focus="getFocusPass"
            @blur="getBlurPass"
            @keyup.enter.native="loginBtn"
            :prefix-icon="
              passType == 0
                ? 'el-icon-login-password'
                : 'el-icon-login-password_active'
            "
          ></el-input>
          <el-button class="login_btn" @click="loginBtn" type="primary">登录</el-button>
          <!-- <el-button class="register_btn" type="primary" plain>注册</el-button> -->
        </div>
      </div>
    </div>
    <div id="loading" v-if="fullscreenLoading">
      <div id="loading-center">
        <div id="loading-center-absolute">
          <div class="object"></div>
          <div class="object"></div>
          <div class="object"></div>
          <div class="object"></div>
          <div class="object"></div>
          <div class="object"></div>
          <div class="object"></div>
          <div class="object"></div>
          <div class="object"></div>
          <div class="object"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loginByPost, getBizList } from "./api/service";
import { pUrl } from "@/api/baseURL.js";
let that;
export default {
  name: "App",
  data() {
    return {
      isUserLogin: false,
      userType: 0,
      passType: 0,
      fullscreenLoading: false,
      form: {},
      formInline: {},
      entpId: ""
    };
  },
  watch: {
    isUserLogin(val, oldVal) {
      this.isUserLogin = val;
      console.log("val:" + val);
    }
  },
  created() {
    // let isLogout=sessionStorage.getItem('isLogout')
    // if(isLogout=='true'){//用户处于退出登录状态
    var type = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
      ? "mobile"
      : "PC";
    if (type == "mobile") {
      this.$router.push({
        path: "/null"
      });
      this.fullscreenLoading = false;
      return false;
    }
    // }else{
    // console.log(this.isRegister)
    that = this;
    window.addEventListener("setItem", function() {
      that.isUserLogin =
        sessionStorage.getItem("$isUserLogin") == "false" ? true : false;
      that.fullscreenLoading =
        sessionStorage.getItem("fullscreenLoading") == "false" ? false : true;
      var timeOut;
      if (that.fullscreenLoading == "true") {
        timeOut = setTimeout(function() {
          that.fullscreenLoading = false;
          this.resetSetItem("fullscreenLoading", false);
        }, 60000);
      } else {
        clearTimeout(timeOut);
      }
    });
    // }
  },
  methods: {
    getFocusUser() {
      this.userType = 1;
    },
    getBlurUser() {
      this.userType = 0;
    },
    getFocusPass() {
      this.passType = 1;
    },
    getBlurPass() {
      this.passType = 0;
    },
    outerDia() {
      this.isUserLogin = false;
      sessionStorage.setItem("$isUserLogin", true);
      this.resetSetItem("$isUserLogin", true);
    },
    interDia(e) {
      e.stopPropagation();
    },
    loginBtn() {
      this.entpId = localStorage.getItem("enterpriseId");
      if (!this.formInline.username) {
        this.$message({
          title: "警告",
          message: "请填写用户名",
          type: "warning"
        });
      } else if (!this.formInline.password) {
        this.$message({
          title: "警告",
          message: "请填写密码",
          type: "warning"
        });
      } else {
        let url = "employee/enterpriseEmployeeLogin";
        let data = {
          username: this.formInline.username,
          password: this.formInline.password,
          entpId: this.entpId,
          userType: "05"
        };
        this.$store
          .dispatch("Login", data)
          .then(() => {
            this.isUserLogin = false;
            this.$router.go(0);
          })
          .catch(() => {});
      }
    },
    cancel() {
      sessionStorage.setItem("$isUserLogin", true);
      this.resetSetItem("$isUserLogin", true);
    }
  }
};
</script>

<style>
.login_btn {
  width: 80%;
  height: 40px;
  margin-left: 10% !important;
  margin-top: 59px !important;
}
.register_btn {
  width: 80%;
  height: 40px;
  margin-left: 10% !important;
  margin-top: 12px;
}
.el-icon-login-user_active {
  background: url(../static/20210517new/username_active.png) center no-repeat;
  background-size: 16px 18px;
}
.el-icon-login-user {
  background: url(../static/20210517new/username.png) center no-repeat;
  background-size: 16px 18px;
}
.el-icon-login-user:before {
  content: "\66ff";
  font-size: 16px;
  visibility: hidden;
}
.el-icon-login-password_active {
  background: url(../static/20210517new/password_active.png) center no-repeat;
  background-size: 16px 18px;
}
.el-icon-login-password {
  background: url(../static/20210517new/password.png) center no-repeat;
  background-size: 16px 18px;
}
.el-icon-login-password:before {
  content: "\66ff";
  font-size: 16px;
  visibility: hidden;
}
.login_title {
  text-align: center;
  margin-top: 55px;
  font-size: 24px;
  font-weight: bold;
  color: #3482ff;
}
.formInline {
  width: 80%;
  margin-left: 20%;
  margin-top: 20px;
}
.hearder_title_close {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 20px;
  right: 20%;
  cursor: pointer;
}
.hearder_title {
  width: 70%;
  height: 30px;
  margin: auto;
  font-size: 24px;
  line-height: 30px;
  margin-top: 20px;
  margin-bottom: 30px;
  text-align: center;
}
.loginDia {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 999;
}
.loginBody {
  max-width: 750px;
  height: 443px;
  margin: auto;
  margin-top: 200px;
  background-size: 100% 100%;
  position: relative;
  /* overflow: hidden; */
  background-color: #fff;
  border-radius: 20px;
  position: relative;
}
.cancel_icon {
  width: 46px;
  height: 46px;
  position: absolute;
  right: -17px;
  top: -17px;
  z-index: 99;
}
.loginBody_left {
  width: 48%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.loginBody_right {
  width: 52%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  /* margin-top: 60px; */
}

/* /* padding-right: 80px !important; */

.el-dialog__headerbtn .el-dialog__close {
  color: #fff !important;
  font-size: 20px !important;
  padding-right: 10px !important;
}
.el-dialog__header {
  background: #3482ff !important;
  text-align: center;
}
.el-dialog__title {
  color: #fff;
  line-height: 24px;
  font-size: 24px;
}
.el-dialog {
  -webkit-box-shadow: none !important;
}

.el-dialog--center .el-dialog__body {
  background: #fff;
}

.el-dialog--center .el-dialog__body {
  padding: 25px 120px 30px !important;
}

.el-message {
  top: 40% !important;
}
/* .el-loading-mask { */
/* top: 60px !important; */
/* } */
.el-loading-spinner i {
  color: #3482ff;
  font-size: 50px;
}
.el-loading-spinner .el-loading-text {
  color: #3482ff;
  margin: 3px 0;
  font-size: 18px;
}

#loading {
  background-color: rgba(0, 0, 0, 0);
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 1;
  margin-top: 0px;
  top: 0px;
}
#loading-center {
  width: 100%;
  height: 100%;
  position: relative;
}
#loading-center-absolute {
  position: absolute;
  left: 50%;
  top: 50%;
  height: 50px;
  width: 150px;
  margin-top: -25px;
  margin-left: -75px;
}
.object {
  width: 8px;
  height: 50px;
  margin-right: 5px;
  background-color: #3482ff;
  -webkit-animation: animate 1s infinite;
  animation: animate 1s infinite;
  float: left;
}

.object:last-child {
  margin-right: 0px;
}

.object:nth-child(10) {
  -webkit-animation-delay: 0.9s;
  animation-delay: 0.9s;
}
.object:nth-child(9) {
  -webkit-animation-delay: 0.8s;
  animation-delay: 0.8s;
}
.object:nth-child(8) {
  -webkit-animation-delay: 0.7s;
  animation-delay: 0.7s;
}
.object:nth-child(7) {
  -webkit-animation-delay: 0.6s;
  animation-delay: 0.6s;
}
.object:nth-child(6) {
  -webkit-animation-delay: 0.5s;
  animation-delay: 0.5s;
}
.object:nth-child(5) {
  -webkit-animation-delay: 0.4s;
  animation-delay: 0.4s;
}
.object:nth-child(4) {
  -webkit-animation-delay: 0.3s;
  animation-delay: 0.3s;
}
.object:nth-child(3) {
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.2s;
}
.object:nth-child(2) {
  -webkit-animation-delay: 0.1s;
  animation-delay: 0.1s;
}
@-webkit-keyframes animate {
  50% {
    -ms-transform: scaleY(0);
    -webkit-transform: scaleY(0);
    transform: scaleY(0);
  }
}
@keyframes animate {
  50% {
    -ms-transform: scaleY(0);
    -webkit-transform: scaleY(0);
    transform: scaleY(0);
  }
}
.el-menu--horizontal > .el-submenu .el-submenu__title {
  font-size: 16px !important;
}
.el-menu-item,
.el-submenu__title {
  line-height: 60px !important;
}
/* .el-form-item__label{
  line-height:70px!important;
}
.el-form-item {
   margin-bottom:0!important;
} */
.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  line-height: 36px !important;
}
/* .diy_dialog .el-dialog__headerbtn .el-dialog__close {
  padding-right: 10px !important;
} */
</style>

<style  scoped>
.login_class {
  background: url("../static/bg.png") 0 0 no-repeat !important;
  background-size: 100% 100% !important;
  padding: 0 30px;
}

.el-dialog__header {
  background: #fff;
  text-align: center;
}

.el-dialog__headerbtn .el-dialog__close {
  color: #333 !important;
  padding-right: 100px !important;
  font-size: 20px !important;
}

.icon_01 {
  width: 25px !important;
  height: 25px !important;
  display: inline-block;
  background: url("../static/login_icon_01.jpg") 0 0 no-repeat;
  background-size: 100% 100% !important;
  vertical-align: bottom;
}
.icon_02 {
  width: 25px !important;
  height: 25px !important;
  display: inline-block;
  background: url("../static/login_icon_02.jpg") 0 0 no-repeat;
  background-size: 100% 100% !important;
  vertical-align: bottom;
}
.login_button {
  width: 70% !important;
  margin: 70px auto 0;
  display: block;
  border-radius: 30px;
  background: linear-gradient(to right, #74a9fe, #3583fe) !important;
  box-shadow: 3px 4px 10px #6ea6fe !important;
  height: 50px !important;
  line-height: 50px !important;
  color: #fff;
  font-size: 28px;
}
</style>


// WEBPACK FOOTER //
// src/App.vue